function focus(id) {
  document.getElementById(id).focus();
}


function click(id) {
  document.getElementById(id).click();
}
